import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import {
  Button,
  FormControlLabel,
  Checkbox,
  TextField,
  Select,
  MenuItem,
  Paper,
  InputLabel,
} from "@material-ui/core";
import Axios from "axios";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DownloadIcon from "@mui/icons-material/Download";
// import FilterTable from '../components/filtertable';
import InvestmentOverView from "../investment/investmentOverview";
import InvImportantTabs from "./invImportant";
import InvestmentReviewTabs from "./invInvestmentTabs";
import InvestorPortFolioOverAll from "../investment/investorPortfolioOverAll";
import Executivelist from "../investment/executivelist";
import InvAllTasklist from "../investment/invalltasklist";
import { useHistory, useLocation } from "react-router-dom";
import ProspectOverView from "../prospect/prospectOverview";
import DiscountOverView from "../prospect/discountManager";
import TicketOverView from "../prospect/ticketManager";
import ProspectExecutivelist from "../prospect/propectexelist";
import {
  addProspectPath,
  addTicketPath,
  addNotificationPath,
  franchiseDashboard,
} from "../utils/varialbles";
import http from "../services/httpService";
import Export from "../services/Export";
import Prospectalltasks from "../prospect/prospectalltasks";
import toast from "react-hot-toast";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Draggable from "react-draggable";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
let enablenoOfRecords = true;

function Prospect({ props }) {
  const classes = useStyles();
  // let match = useRouteMatch();
  const [value, setValue] = React.useState(0);
  const [showAddBtn, setShowAddBtn] = useState(false);
  const [loadTabs, setLoadTabs] = useState(false);
  const [addNotify, setAddNotify] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [passRecords, setPassRecords] = useState(false);
  const [formObject, setFormObject] = useState({
    allDownload: true,
    enteredRecordsCount: 0,
  });
  const [tabs, setTabs] = useState([]);
  const [multipleSelected, setMultipleSelected] = useState("");
  const [multipleSelectedstatus, setMultipleSelectedstatus] = useState("");
  const [multipleProspect, setMultipleProspect] = useState([]);
  const [status, setStatus] = useState([]);
  const [selectedId, setSelectedId] = useState([]);
  const location = useLocation();
  const [openCommentsModal, setOpenCommentsModal] = useState(false);
  const [openDownloadModal, setOpenDownloadModal] = useState(false);
  const [executiveList, setExecutiveList] = useState([]);
  const [rmSource, setRMSource] = useState([]);

  const myparam = location.state;

  const [addTab, setAddTab] = React.useState({});
  let history = useHistory();
  const addProspect = (event) => {
    event.preventDefault();
    if (addTab["path"]) {
      history.push(addTab["path"]);
    }
  };

  const handleChange = (event, newValue) => {
    if (tabs[newValue]["path"]) {
      setShowAddBtn(true);
    } else {
      setShowAddBtn(false);
    }
    setAddTab(tabs[newValue]);
    setValue(newValue);
  };
  const handleChangeComments = (event) => {
    setFormObject({
      ...formObject,
      [event.target.name]: event.target.value,
    });
  };
  const CHARACTER_LIMIT = 255;

  const getSelectedId = (id) => {
    setSelectedId(id);

    // if (id.length !== 0) {
    //   id.map((es) => {
    //     // idss.push(es)
    //     selectedId.push(es)
    //   })
    // }
    // else {
    //   setSelectedId([]);
    //   selectedId.splice(0, selectedId.length)

    // }
    // if (Array.isArray(id)) {
    //   // id.map((es) => {
    //   //   // idss.push(es)
    //   //   selectedId.push(es)
    //   // })
    // }
    // // else if (id !== "") {
    // //   selectedId.push(id)
    // // }
    // else {
    //   setSelectedId([]);
    //   selectedId.splice(0, selectedId.length)

    // }
    // selectedId.map((es) => {
    //   if (Array.isArray(id)) {
    //     ('am es', es);
    //     // selectedId.push(es)
    //   }
    //   // else {
    //   //   selectedId.push(id)

    //   // }
    // })
  };

  const getState = (newValue) => {
    if (newValue === true) {
      setAddNotify(true);
    } else {
      setAddNotify(false);
    }
  };

  const gotoFranchiseDashboard = (object) => {
    // let datas = selectedId;
    history.push({
      pathname: franchiseDashboard,
      // state: datas,
    });
  };
  const handleCloseModal = () => {
    setOpenCommentsModal(false);
    setOpenDownloadModal(false);
    setShowProgressBar(false);
  };

  let tabsList = [
    {
      name: "Overview",
      child: InvestmentOverView,
      sub: "Add prospect",
      props: {
        showProgressBar: showProgressBar,
        passRecords: passRecords,
        recordsCount: formObject.enteredRecordsCount,
        handleCloseModal: handleCloseModal,
        getState: getState,
        getSelectedId: getSelectedId,
        data: showAlert,
      },
    },
    {
      name: "Portfolio",
      child: InvestorPortFolioOverAll,
      sub: "Discount Rquest",
    },
    {
      name: "Investments",
      child: InvestmentReviewTabs,
      sub: "Add Ticket",
    },
    {
      name: "Discount Manager",
      child: DiscountOverView,
      sub: "Add Ticket",
    },
    {
      name: "Important",
      child: InvImportantTabs,
      sub: "Add Ticket",
    },
    {
      name: "Executive List",
      child: Executivelist,
      sub: "Add Ticket",
    },
    {
      name: "All Tasks",
      child: InvAllTasklist,
    },
  ];
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 250 },
    },
    getContentAnchorEl: null,
    anchorOrigin: { vertical: "bottom", horizontal: "center" },
    transformOrigin: { vertical: "top", horizontal: "center" },
    variant: "menu",
  };

  useEffect(() => {
    rmNamesList();
    loginPermissions();
    enablenoOfRecords = true;
  }, [showAlert, showProgressBar]);

  useEffect(() => {}, [passRecords, showAlert]);

  // const loginPermissions = () => {
  //   http
  //     .get("/login_permissions")
  //     .then((res) => {
  //       if (
  //         res &&
  //         res.data &&
  //         res.data.Data &&
  //         Array.isArray(res.data.Data) &&
  //         res.data.Data.length > 0
  //       ) {
  //         let current_permission = res.data.Data.filter((obj) => {
  //           return obj.Mainmenu === "Investor Manager";
  //         });
  //         if (current_permission && current_permission.length > 0) {
  //           let finalTabsList = tabsList.filter((object) => {
  //             if (
  //               current_permission[0]["Submenus"].indexOf(object.name) !== -1
  //             ) {
  //               return object;
  //             }
  //           });
  //           setTabs(finalTabsList);
  //           if (
  //             myparam &&
  //             myparam.tab &&
  //             current_permission[0]["Submenus"] &&
  //             current_permission[0]["Submenus"].indexOf(myparam.tab) !== -1
  //           ) {
  //             let ftabs = 0;
  //             finalTabsList.map((obj, inx) => {
  //               if (obj.name === myparam.tab) {
  //                 ftabs = inx;
  //               }
  //             });
  //             let tab = ftabs;
  //             setAddTab(finalTabsList[tab]);
  //             if (finalTabsList[tab]["path"]) {
  //               setShowAddBtn(true);
  //             }
  //             setValue(tab);
  //           } else {
  //             setAddTab(finalTabsList[0]);
  //             if (finalTabsList[0]["path"]) {
  //               setShowAddBtn(true);
  //             } else {
  //               setShowAddBtn(false);
  //             }
  //             setLoadTabs(true);
  //             setValue(0);
  //           }
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       //  console.log('error')
  //     });
  // }

  const loginPermissions = () => {
    http
      .get("/login_permissions")
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.Data &&
          Array.isArray(res.data.Data) &&
          res.data.Data.length > 0
        ) {
          let current_permission = res.data.Data.filter((obj) => {
            return obj.Mainmenu === "Investor Manager";
          });
          if (current_permission && current_permission.length > 0) {
            let finalTabsList = tabsList.filter((object) => {
              if (
                current_permission[0]["Submenus"].indexOf(object.name) !== -1
              ) {
                return object;
              }
            });
            setTabs(finalTabsList);

            if (
              myparam &&
              myparam.tab &&
              current_permission[0]["Submenus"] &&
              current_permission[0]["Submenus"].indexOf(myparam.tab) !== -1
            ) {
              let ftabs = 0;
              finalTabsList.map((obj, inx) => {
                if (obj.name === myparam.tab) {
                  ftabs = inx;
                }
              });
              let tab = ftabs;
              setValue(tab);
              setLoadTabs(true);
            } else {
              setValue(0);
            }
            setLoadTabs(true);
          }
        }
      })
      .catch((error) => {});
  };

  const handleLangChange = (e) => {
    setMultipleSelected(e.target.value);
    console.log(e.target.value);
  };

  const handleStatusChange = (e) => {
    setMultipleSelectedstatus(e.target.value);
  };

  const handleRMSourceChange = (e) => {
    let abcd = executiveList.filter((item) => {
      return item.value === e.target.value;
    });
    setRMSource(abcd);
  };

  // calling inv rmnames list
  const rmNamesList = () => {
    http
      .get("rmchangeinv")
      .then((res) => {
        // setCountryValidations(res.data.Data);
        setMultipleProspect(res.data.rms);
        setStatus(res.data.crt_status);

        let crtlistoptions = res.data.crt;
        const crtdropdown = [
          {
            value: 1,
            name: "CRT Name",
            options: [],
          },
        ];

        // Setting the "options" key of the "arrayObject" to the entire "crt" array
        crtdropdown[0].options = crtlistoptions;

        setExecutiveList(crtdropdown);
      })
      .catch((err) => {
        // toast.error("Questioner Data Not Available for this investor..!")
      });
  };

  // Commented this function
  const postingRmnamesList = () => {
    setShowAlert(false);
    if (
      (multipleSelected === "" || selectedId.length === 0) &&
      (multipleSelectedstatus === "" || selectedId.length === 0)
    ) {
      toast.error("Please select the RM Names list or Status");
    } else if (multipleSelected !== "") {
      setOpenCommentsModal(!openCommentsModal);
    } else {
      changeStatus();
    }
  };

  // url=jhvdjkvh/ramchange?cutid=yy&status=ghh;
  //   (selectedId);
  const changeStatus = () => {
    setShowAlert(false);
    const baserm = "/rmchangeinv";
    let post_url = "";
    if (multipleSelected && multipleSelectedstatus) {
      post_url = `${baserm}?emp_id=${multipleSelected}&cust_id=${selectedId}&crt_status=${multipleSelectedstatus}`;
    } else if (multipleSelected) {
      post_url = `${baserm}?emp_id=${multipleSelected}&cust_id=${selectedId}`;
    } else {
      post_url = `${baserm}?cust_id=${selectedId}&crt_status=${multipleSelectedstatus}`;
    }

    http
      .post(post_url)
      .then((res) => {
        toast.success(res.data.rms);
        setShowAlert(true);
        setSelectedId([]);
        selectedId.splice(0, selectedId.length);
        setAddNotify(false);
        //State to call API

        setMultipleSelected("");
        setMultipleSelectedstatus("");
      })
      .catch((err) => {
        // toast.error("Questioner Data Not Available for this investor..!")
      });
  };
  const postAssignedComments = () => {
    setShowAlert(false);
    const baserm = "/rmchangeinv";
    let post_url = "";
    if (multipleSelected && multipleSelectedstatus) {
      post_url = `${baserm}?emp_id=${multipleSelected}
      &cust_id=${selectedId}&crt_status=${multipleSelectedstatus}
      &comments=${formObject.assigned_comments}
      `;
    } else if (multipleSelected) {
      post_url = `${baserm}?emp_id=${multipleSelected}
      &cust_id=${selectedId}&comments=${formObject.assigned_comments}
      `;
    } else {
      post_url = `${baserm}?cust_id=${selectedId}&crt_status=${multipleSelectedstatus}`;
    }

    if (formObject.assigned_comments !== "") {
      http
        .post(post_url)
        .then((res) => {
          toast.success(res.data.rms);
          setShowAlert(true);
          setSelectedId([]);
          selectedId.splice(0, selectedId.length);
          setAddNotify(false);
          setOpenCommentsModal(!openCommentsModal);
          setMultipleSelected("");
          setFormObject({
            ...formObject,
            assigned_comments: "",
          });
          // setMultipleSelectedstatus("");
        })
        .catch((err) => {
          ("am error");
        });
    } else {
      toast.error("Enter Comments");
    }
  };
  const downloadModalOpen = () => {
    setOpenDownloadModal(true);
  };
  const handleChangeDownload = (e) => {
    setFormObject({
      ...formObject,
      allDownload: e.target.checked,
    });
    if (e.target.checked === false) {
      enablenoOfRecords = false;
    } else {
      enablenoOfRecords = true;
    }
  };
  const handleChangeRecords = (e) => {
    setFormObject({
      ...formObject,
      enteredRecordsCount: e.target.value,
    });
  };
  const getRecordsList = () => {
    setShowProgressBar(true);
    setOpenDownloadModal(false);
    let finalObject = { ...formObject };
    let records =
      finalObject.allDownload === true
        ? "all"
        : finalObject.enteredRecordsCount;
    Export.get(`investors?records=${records}`, {
      responseType: "arraybuffer",
    })
      .then((response) => {
        setShowProgressBar(false);
        setPassRecords(true);
        enablenoOfRecords = false;
        setFormObject({
          ...formObject,
          allDownload: true,
        });
        // const url = window.URL.createObjectURL(new Blob([response.data]));
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/zip" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `investors-${records}.zip`);
        document.body.appendChild(link);
        link.click();
        toast.success("Successfully Downloaded");
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        // (err)
        setShowProgressBar(false);
      });
    // let token = localStorage.getItem('token')
    // const authDetails = {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // };
    // Axios.get(`http://localhost:8000/excel/investors?records=${records}`, authDetails)
    //   .then(response => {
    //     setShowProgressBar(false);
    //     setPassRecords(true);
    //     const url = window.URL.createObjectURL(new Blob([response.data]));
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.setAttribute('download', `investors-${records}.csv`);
    //     document.body.appendChild(link);
    //     link.click();
    //     toast.success('Successfully Downloaded')
    //   })
    //   .catch((error) => {
    //     setShowProgressBar(false);
    //     // console.log(error);
    //   });
  };

  return (
    <>
      {loadTabs ? (
        <div className={(classes.root, "pb30")}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
              indicatorColor="primary"
              textColor="primary"
              TabIndicatorProps={{ style: { display: "none" } }}
              id="tabs_static"
            >
              {tabs.map((text, index) => (
                <Tab
                  label={text.name}
                  key={index}
                  {...a11yProps(index)}
                  style={{ borderRadius: 20, marginBottom: 20 }}
                ></Tab>
              ))}
              <div>
                {showAddBtn ? (
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: 10, borderRadius: 60 }}
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={addProspect}
                    className={"addBtn"}
                  >
                    {addTab["sub"]}
                  </Button>
                ) : (
                  ""
                )}
              </div>
              {localStorage.getItem("empRole") === "CTO" ||
              localStorage.getItem("empRole") === "CEO" ||
              localStorage.getItem("empRole") === "Sales Manager" ? (
                <>
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginLeft: 10, borderRadius: 60 }}
                      startIcon={<DownloadIcon />}
                      onClick={downloadModalOpen}
                      className={"addBtn"}
                    >
                      Export
                    </Button>
                  </div>
                </>
              ) : (
                ""
              )}
              {addNotify === true ? (
                <div
                  id="dropdowns"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {localStorage.getItem("empRole") === "CEO" ||
                  localStorage.getItem("empRole") === "Sales Manager" ||
                  localStorage.getItem("empRole") === "MF Manager" ||
                  localStorage.getItem("empRole") === "Franchise" ? (
                    <>
                      <Select
                        displayEmpty
                        labelId="rmnames"
                        id="rmnames"
                        variant="outlined"
                        className={classes.select}
                        value={multipleSelected ? multipleSelected : ""}
                        onChange={handleLangChange}
                        style={{
                          width: "150px",
                          marginLeft: "10px",
                          marginBottom: 20,
                        }}
                      >
                        <MenuItem value="">RMNames</MenuItem>
                        {multipleProspect.map((option) => (
                          <MenuItem value={option.id} key={option.id}>
                            {option.empfname}
                          </MenuItem>
                        ))}
                      </Select>
                    </>
                  ) : (
                    ""
                  )}
                  {localStorage.getItem("empRole") === "CTO" ? (
                    <>
                      <Select
                        displayEmpty
                        labelId="Source"
                        id="Source"
                        variant="outlined"
                        className={classes.select}
                        onChange={handleRMSourceChange}
                        style={{
                          width: "180px",
                          marginLeft: "10px",
                          marginBottom: 20,
                        }}
                      >
                        <MenuItem>Source</MenuItem>
                        {executiveList.map((option) => (
                          <MenuItem value={option.value} key={option.value}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {rmSource.length !== 0 ? (
                        <>
                          <Select
                            displayEmpty
                            labelId="Source"
                            id="Source"
                            variant="outlined"
                            className={classes.select}
                            value={multipleSelected ? multipleSelected : ""}
                            onChange={handleLangChange}
                            style={{
                              width: "150px",
                              marginLeft: "10px",
                              marginBottom: 20,
                            }}
                          >
                            <MenuItem value="">Executive</MenuItem>
                            {rmSource[0].options.map((option) => (
                              <MenuItem value={option.id} key={option.id}>
                                {option.empfname}
                              </MenuItem>
                            ))}
                          </Select>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {localStorage.getItem("empRole") === "CTO" ||
                  localStorage.getItem("empRole") === "CEO" ||
                  localStorage.getItem("empRole") === "Sales Manager" ||
                  localStorage.getItem("empRole") === "MF Manager" ||
                  localStorage.getItem("empRole") === "Franchise" ? (
                    <>
                      <Select
                        displayEmpty
                        labelId="statusLable"
                        id="statusSelect"
                        variant="outlined"
                        className={classes.select}
                        value={
                          multipleSelectedstatus ? multipleSelectedstatus : ""
                        }
                        onChange={handleStatusChange}
                        style={{
                          width: "150px",
                          marginLeft: "10px",
                          marginBottom: 20,
                        }}
                      >
                        <MenuItem value="">Status</MenuItem>
                        {status.map((opt) => {
                          return (
                            <MenuItem value={opt.value} key={opt.value}>
                              {opt.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </>
                  ) : (
                    ""
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      marginLeft: 20,
                      borderRadius: 60,
                      marginBottom: 20,
                    }}
                    //  startIcon={<AddCircleOutlineIcon />}
                    className={"addBtn"}
                    // onClick={postingRmnamesList}
                    onClick={postingRmnamesList}
                  >
                    Update
                  </Button>
                </div>
              ) : (
                ""
              )}
            </Tabs>
          </AppBar>
          {/* <div>
            Dashboard
          </div> */}

          {tabs.map((object, index) => {
            return (
              <TabPanel value={value} index={index} key={"tab" + index}>
                {React.createElement(object.child, object.props)}
              </TabPanel>
            );
          })}
        </div>
      ) : (
        ""
      )}

      <Dialog
        open={openCommentsModal}
        onClose={handleCloseModal}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {/* Delete User */}
          <InputLabel
            id="emailIDLable"
            style={{ fontWeight: "bold", color: "#000" }}
          >
            Comments
          </InputLabel>
          <TextField
            id="outlined-basic"
            placeholder="Comments"
            variant="outlined"
            multiline
            fullWidth
            value={formObject.assigned_comments}
            maxRows={4}
            name="assigned_comments"
            onChange={handleChangeComments}
            inputProps={{
              maxlength: CHARACTER_LIMIT,
            }}
            helperText={
              formObject.assigned_comments
                ? `${formObject.assigned_comments.length}/${CHARACTER_LIMIT}`
                : ""
            }
          />
        </DialogTitle>
        <DialogContent>
          {/* Are you sure to Delete {currentUser.empfname}? */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} variant="outlined">
            No
          </Button>
          <Button
            style={{ textTransform: "capitalize" }}
            autoFocus
            onClick={postAssignedComments}
            variant="contained"
            color="primary"
          >
            Re-assign
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDownloadModal}
        onClose={handleCloseModal}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {/* Delete User */}
          <FormControlLabel
            control={
              <Checkbox
                // checked={formObject["sub" + obj.id + "__" + sub.id]}
                color="primary"
                onChange={handleChangeDownload}
                checked={formObject.allDownload}
                // defaultChecked
                // name={"sub" + obj.id + "__" + sub.id}
              />
            }
            label="All"
          />
          <InputLabel
            id="emailIDLable"
            style={{ fontWeight: "bold", color: "#000" }}
          ></InputLabel>
          <TextField
            id="outlined-basic"
            placeholder="Number of records"
            variant="outlined"
            type="number"
            value={formObject.enteredRecordsCount}
            disabled={enablenoOfRecords === true ? true : false}
            name="enteredRecordsCount"
            onChange={handleChangeRecords}
          />
        </DialogTitle>
        <DialogContent>
          {/* Are you sure to Delete {currentUser.empfname}? */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} variant="outlined">
            Cancel
          </Button>
          <Button
            style={{ textTransform: "capitalize" }}
            autoFocus
            onClick={getRecordsList}
            variant="contained"
            color="primary"
          >
            Download Investors
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default Prospect;
